<template>
  <div class="control-region-page">
    <h4 class="control-region-page__title">管控区域维护</h4>
    <el-form :inline="true" :model="queryParams" size="small" class="control-region-page__form">
      <el-form-item>
        <el-input v-model="queryParams.regionName" placeholder="区域名称" clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model="queryParams.controlLevel" placeholder="管控等级" clearable style="width: 130px">
          <el-option label="一级管控" :value="1" />
          <el-option label="二级管控" :value="2" />
          <el-option label="三级管控" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="queryParams.statusName" placeholder="状态" clearable style="width: 110px">
          <el-option label="生效" :value="1" />
          <el-option label="失效" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-plus" type="success" @click="openAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="tableData"
      height="calc(100% - 140px)"
      border
      size="small"
      class="control-region-page__table"
    >
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="regionName" label="区域名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="controlLevel" label="管控等级" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="getLevelTagType(scope.row.controlLevel)" size="small">
            {{ getLevelName(scope.row.controlLevel) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="坐标点数" width="100" align="center">
        <template slot-scope="scope">{{ getPointCount(scope.row.polygonPath) }}</template>
      </el-table-column>
      <el-table-column prop="statusName" label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.statusName === 1 ? 'success' : 'info'" size="small">
            {{ scope.row.statusName === 1 ? "生效" : "失效" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="160" align="center" />
      <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
      <el-table-column label="操作" width="230" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="openEdit(scope.row)">修改</el-button>
          <el-button
            :type="scope.row.statusName === 1 ? 'info' : 'success'"
            size="mini"
            @click="switchStatus(scope.row)"
          >
            {{ scope.row.statusName === 1 ? "失效" : "生效" }}
          </el-button>
          <el-button type="danger" size="mini" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="control-region-page__pager">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pageIndex"
        :page-size="pageRow"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="72%"
      :close-on-click-modal="false"
      @opened="initEditMap"
      @closed="destroyEditMap"
    >
      <el-form :model="dataForm" label-width="90px" size="small">
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="区域名称">
              <el-input v-model="dataForm.regionName" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="管控等级">
              <el-select v-model="dataForm.controlLevel" style="width: 100%">
                <el-option label="一级管控" :value="1" />
                <el-option label="二级管控" :value="2" />
                <el-option label="三级管控" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-select v-model="dataForm.statusName" style="width: 100%">
                <el-option label="生效" :value="1" />
                <el-option label="失效" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="dataForm.remark" />
        </el-form-item>
        <el-form-item label="区域坐标">
          <el-input
            v-model="dataForm.polygonPath"
            type="textarea"
            :rows="3"
            placeholder="请在地图上绘制，或输入 [[经度,纬度],[经度,纬度],[经度,纬度]]"
            @blur="previewFromInput"
          />
        </el-form-item>
        <div class="control-region-page__map-toolbar">
          <el-button type="primary" size="mini" @click="startDraw">开始绘制</el-button>
          <el-button size="mini" @click="previewFromInput">预览坐标</el-button>
          <el-button size="mini" @click="clearDraw">清除</el-button>
        </div>
        <div ref="editMap" class="control-region-page__map"></div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitDialog">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Gkqy",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageRow: 10,
      queryParams: {},
      dialogVisible: false,
      dialogTitle: "",
      dataForm: {},
      editMap: null,
      editMouseTool: null,
      editPolygon: null
    };
  },
  methods: {
    handleQuery() {
      this.pageIndex = 1;
      this.getData();
    },
    handleSizeChange(size) {
      this.pageRow = size;
      this.pageIndex = 1;
      this.getData();
    },
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.getData();
    },
    getData() {
      this.loading = true;
      const data = Object.assign({}, this.queryParams, {
        pageIndex: this.pageIndex,
        pageRow: this.pageRow
      });
      this.$http.POST_controlRegionList(data).then(res => {
        const page = res.data || {};
        this.tableData = page.records || [];
        this.total = page.total || res.total || 0;
      }).finally(() => {
        this.loading = false;
      });
    },
    openAdd() {
      this.dialogTitle = "新增管控区域";
      this.dataForm = {
        regionName: "",
        controlLevel: 1,
        statusName: 1,
        polygonPath: "",
        remark: ""
      };
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogTitle = "修改管控区域";
      this.dataForm = Object.assign({}, row);
      this.dialogVisible = true;
    },
    submitDialog() {
      const path = this.parsePath(this.dataForm.polygonPath);
      if (!this.dataForm.regionName) {
        this.$message.warning("请输入区域名称");
        return;
      }
      if (!this.dataForm.controlLevel) {
        this.$message.warning("请选择管控等级");
        return;
      }
      if (path.length < 3) {
        this.$message.warning("请至少绘制三个坐标点");
        return;
      }
      const data = Object.assign({}, this.dataForm, {
        polygonPath: JSON.stringify(path)
      });
      delete data.createTime;
      delete data.updateTime;
      this.$http.POST_controlRegionAddOrUpdate(data).then(res => {
        if (res.status === "S") {
          this.$message.success("保存成功");
          this.dialogVisible = false;
          this.getData();
        } else {
          this.$message.error(res.msg || "保存失败");
        }
      });
    },
    switchStatus(row) {
      const statusName = row.statusName === 1 ? 0 : 1;
      this.$http.POST_controlRegionEnable({ id: row.id, statusName }).then(res => {
        if (res.status === "S") {
          this.$message.success("状态切换成功");
          this.getData();
        } else {
          this.$message.error(res.msg || "状态切换失败");
        }
      });
    },
    deleteRow(row) {
      this.$confirm("确定要删除该管控区域吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http.GET_controlRegionDel({ paramsID: "/" + row.id }).then(res => {
          if (res.status === "S") {
            this.$message.success("删除成功");
            this.getData();
          } else {
            this.$message.error(res.msg || "删除失败");
          }
        });
      }).catch(() => {});
    },
    initEditMap() {
      if (typeof AMap === "undefined") {
        this.$message.error("地图组件未加载");
        return;
      }
      this.editMap = new AMap.Map(this.$refs.editMap, {
        viewMode: "2D",
        zoom: 15,
        center: [121.036545, 30.599264],
        mapStyle: "amap://styles/8e9dc097afd432a386f14670244eca1c"
      });
      this.previewFromInput();
    },
    destroyEditMap() {
      if (this.editMouseTool) {
        this.editMouseTool.close(true);
        this.editMouseTool = null;
      }
      if (this.editMap) {
        this.editMap.destroy();
        this.editMap = null;
      }
      this.editPolygon = null;
    },
    startDraw() {
      if (!this.editMap) {
        return;
      }
      if (!AMap.MouseTool) {
        this.$message.error("地图绘制插件未加载");
        return;
      }
      if (this.editMouseTool) {
        this.editMouseTool.close(true);
      }
      this.editMouseTool = new AMap.MouseTool(this.editMap);
      this.editMouseTool.polygon(this.getPolygonStyle(this.dataForm.controlLevel));
      this.editMouseTool.on("draw", event => {
        if (this.editPolygon && this.editPolygon !== event.obj) {
          this.editMap.remove(this.editPolygon);
        }
        this.editPolygon = event.obj;
        const path = this.pathToArray(event.obj.getPath());
        this.dataForm.polygonPath = JSON.stringify(path);
        this.editMouseTool.close(false);
      });
    },
    previewFromInput() {
      const path = this.parsePath(this.dataForm.polygonPath);
      if (path.length >= 3) {
        this.drawPolygon(path);
      }
    },
    clearDraw() {
      if (this.editPolygon && this.editMap) {
        this.editMap.remove(this.editPolygon);
      }
      this.editPolygon = null;
      this.dataForm.polygonPath = "";
    },
    drawPolygon(path) {
      if (!this.editMap) {
        return;
      }
      if (this.editPolygon) {
        this.editMap.remove(this.editPolygon);
      }
      this.editPolygon = new AMap.Polygon(Object.assign({
        path
      }, this.getPolygonStyle(this.dataForm.controlLevel)));
      this.editMap.add(this.editPolygon);
      this.editMap.setFitView([this.editPolygon], false, [40, 40, 40, 40]);
    },
    parsePath(value) {
      if (!value) {
        return [];
      }
      try {
        const raw = JSON.parse(value);
        if (!Array.isArray(raw)) {
          return [];
        }
        return raw.map(item => {
          if (Array.isArray(item)) {
            return [Number(item[0]), Number(item[1])];
          }
          return [Number(item.lng || item.longitude), Number(item.lat || item.latitude)];
        }).filter(item => !isNaN(item[0]) && !isNaN(item[1]));
      } catch (e) {
        return value.split(";").map(item => {
          const point = item.split(",");
          return [Number(point[0]), Number(point[1])];
        }).filter(item => !isNaN(item[0]) && !isNaN(item[1]));
      }
    },
    pathToArray(path) {
      return path.map(item => [Number(item.lng), Number(item.lat)]);
    },
    getPointCount(value) {
      return this.parsePath(value).length;
    },
    getPolygonStyle(level) {
      const styleMap = {
        1: { strokeColor: "#ff3b30", fillColor: "#ff3b30" },
        2: { strokeColor: "#ff9500", fillColor: "#ff9500" },
        3: { strokeColor: "#b00020", fillColor: "#b00020" }
      };
      const style = styleMap[level] || styleMap[1];
      return Object.assign({
        strokeWeight: 2,
        strokeOpacity: 0.95,
        fillOpacity: 0.28,
        zIndex: 20
      }, style);
    },
    getLevelName(level) {
      const map = {
        1: "一级管控",
        2: "二级管控",
        3: "三级管控"
      };
      return map[level] || "未知";
    },
    getLevelTagType(level) {
      const map = {
        1: "danger",
        2: "warning",
        3: "danger"
      };
      return map[level] || "info";
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss">
.control-region-page {
  height: 100%;
  padding: 0 22px 16px;
  color: #fff;
}

.control-region-page__title {
  margin: -30px 0 14px;
  color: aliceblue;
}

.control-region-page__form {
  margin-bottom: 10px;
}

.control-region-page__table {
  color: #333;
}

.control-region-page__pager {
  padding-top: 10px;
  text-align: right;
}

.control-region-page__map-toolbar {
  margin: 0 0 10px 90px;
}

.control-region-page__map {
  height: 360px;
  border: 1px solid #245f92;
}
</style>



// WEBPACK FOOTER //
// src/views/xtgl/gkqy.vue